import Clear from '@/layouts/Clear.vue';

export default {
  path: '/contact-infos',
  component: Clear,
  children: [
    {
      path: '',
      name: 'contact-infos',
      component: () => import('@/views/ClinicContactInfos.vue'),
    },
  ],
};
